var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_37968_44156",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_37968_44156",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB70lEQVR4nO3dzUrDQBiF4XMLvSvrRlCkC++9YqP7LjKzUagMfIsYJMa0Tc6k7wMBoWkT85q/kkEJAAAAAAAAAADgxrTSNktNlk5MuuY2aMq2/jMIMTTbH2KSDmOCsGdovm1AEFUeZOy5B+MQxAxBzBDEDEHMEMQMQSZqpfsk7S99OUuQic79xmLgc7kPmYIgZlppyyGrIll6TtInh6wKYnAOmVGWdv0Yv8UZeD8n9WvuGUn6ytILQYxixOvsIS4xYh6CuMSI+QjiEiPmJYhLjJifIC4x4j0EcYlRJOm1M/9+4PO5D7nATd9u5AOG72UaegCOIFfeM/6LIEYxYlkcslxixPII4hIjlkkQlxixXIK4xIhlE8QlRiyfIC4xYh0IUiTpYepN3yURJJTRSkvHmBQkSY9HaaOVydLH0jFiPRh/0zlkvZUv/srPWghBzBCk9iDlqe+VDI1uRo0Dn9mUq6w1xDiNHgc+s7Mve2ufZIYgawuiymTz9SeIGYKYIYgZgpghiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYIYgZHrbuWfppfIL01BhktQN2jtLGef2G/ivAjzHdNU5JOrTSXfd3S9KT2frZDbkDAAAAoJvzDQufxz3acc4mAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleFullScreen);
export default __webpack_public_path__ + "static/media/toggle-full-screen.f9c0b62ca23c4ee991b79bf3606ee382.svg";
export { ForwardRef as ReactComponent };